"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immer_1 = require("immer");
const getState_1 = require("../helpers/getState");
function applyCheckAnswerCommand(command, states) {
    const { questionId, userId, timeStamp } = command;
    const events = [];
    const updatedStates = immer_1.produce(states, draftStates => {
        const state = getState_1.getStateByContentIdUserId(draftStates, questionId, userId);
        if (new Date(state.updatedAt).getTime() > new Date(timeStamp).getTime()) {
            return;
        }
        state.checkAnswersAttemptCount = (state.checkAnswersAttemptCount || 0) + 1;
        state.lastAccessedOn = state.lastSubmittedOn = state.updatedAt = timeStamp;
    });
    return { states: updatedStates, events, enrolments: [], stateInteractions: [] };
}
exports.applyCheckAnswerCommand = applyCheckAnswerCommand;
//# sourceMappingURL=applyCheckAnswerCommand.js.map